export const subtractFromCurrentDate = (months = 0, years = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  date.setMonth(date.getMonth() - months);

  // Return the new date string as an ISO string
  return date.toISOString();
};

export const marks = [
  {
    value: 1,
    dateString: subtractFromCurrentDate(3, 0),
    label: '3 months',
  },
  {
    value: 2,
    dateString: subtractFromCurrentDate(6, 0),
    label: '6 months',
  },
  {
    value: 3,
    dateString: subtractFromCurrentDate(9, 0),
    label: '9 months',
  },
  {
    value: 4,
    dateString: subtractFromCurrentDate(12, 0),
    label: '1 year',
  },
  {
    value: 5,
    dateString: subtractFromCurrentDate(0, 2),
    label: '2 years',
  },
  {
    value: 6,
    dateString: subtractFromCurrentDate(0, 3),
    label: '3 years',
  },
  {
    value: 7,
    dateString: subtractFromCurrentDate(0, 4),
    label: '4 years',
  },
  {
    value: 8,
    dateString: subtractFromCurrentDate(0, 5),
    label: '5 years',
  },
  {
    value: 9,
    dateString: subtractFromCurrentDate(0, 6),
    label: '6 years',
  },
  {
    value: 10,
    dateString: subtractFromCurrentDate(0, 7),
    label: '7 years',
  },
  {
    value: 11,
    dateString: subtractFromCurrentDate(0, 8),
    label: '8 years',
  },
  {
    value: 12,
    dateString: subtractFromCurrentDate(0, 9),
    label: '9 years',
  },
  {
    value: 13,
    dateString: subtractFromCurrentDate(0, 10),
    label: '10 years',
  },
  {
    value: 14,
    dateString: subtractFromCurrentDate(0, 11),
    label: '11 years',
  },
  {
    value: 15,
    dateString: subtractFromCurrentDate(0, 12),
    label: '12 years',
  },
  {
    value: 16,
    dateString: subtractFromCurrentDate(0, 13),
    label: '13 years',
  },
  {
    value: 17,
    dateString: subtractFromCurrentDate(0, 14),
    label: '14 years',
  },
  {
    value: 18,
    dateString: subtractFromCurrentDate(0, 15),
    label: '15 years',
  },
];
